import React from "react";
import DeleteOutlined from "@ant-design/icons/DeleteOutlined";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import { connect } from "react-redux";
import Form from "components/UI/Form";
import { Checkbox, Table, Input, Select, Button, Popconfirm } from "antd";
import InputNumber from "components/UI/InputNumber";
import moment from "moment";
import DateInput from "components/UI/DateInputWithHourAndMinute";
import EmployeeInfoView from "components/UI/EmployeeInfoView";
import EmployeeSelect from "components/UI/EmployeeSelect";
import InputInTable from "components/UI/InputInTable";
import "./styles.scss";

const Option = Select.Option;
const OptGroup = Select.OptGroup;
const EditableContext = React.createContext();
// Hồ sơ gấp: phải khớp với Request::URGENT_TASK_TYPES (backend)
export const urgentTaskTypes = {
  "gap-nhan-hieu-chu": { name: "Gấp: Nhãn hiệu chữ", shortName: "Chữ", weight: 1 },
  "gap-nhan-hieu-hinh": { name: "Gấp: Nhãn hiệu hình", shortName: "Hình", weight: 2 },
  "gap-gia-han": { name: "Gấp: Hồ sơ gia hạn đến hạn cuối cùng", shortName: "Gia hạn", weight: 2 },
  "gap-phan-doi-cap": { name: "Gấp: Phản đối cấp ngày cuối cùng", shortName: "PĐC", weight: 2 },
  "gap-khieu-nai": { name: "Gấp: Khiếu nại ngày cuối", shortName: "KN", weight: 2 },
};
const urgentTaskTypeNames = Object.keys(urgentTaskTypes).reduce(
  (acc, key) => ({ ...acc, [key]: urgentTaskTypes[key].name }),
  {},
);
export const isUrgentTaskType = (taskType) => !!urgentTaskTypes[taskType];
// Mã NV được tick "Không ghi nhận" (phải khớp Request::TASK_NOT_RECORDED_USER_IDENTIFICATIONS)
export const TASK_NOT_RECORDED_USER_IDENTIFICATIONS = ["2"];
export const canSetTaskNotRecorded = (userState) =>
  !!userState &&
  TASK_NOT_RECORDED_USER_IDENTIFICATIONS.includes(
    String(userState.identification),
  );
export const taskTypesKinhDoanhForSelectOnly = {
  "ky-hd": "Ký HD",
  "tao-bl": "Tạo BL",
  "ghi-nhan-ds": "Ghi nhận DS",
  "xuat-hoa-don": "Xuất hóa đơn",
  "cong-viec-khac": "Công việc khác",
  "rut-don": "Rút đơn",
  "giao-nhan-ho-so": "Giao/Nhận hồ sơ",
  // loại công việc Kinh doanh, KHÔNG phải hồ sơ gấp tính điểm (urgentTaskTypes)
  "kd-gap": "Gấp",
};
// not in taskTypesKinhDoanhForSelectOnly but in taskTypes
export const taskTypesXuLyForSelectOnly = {
  "nop-don": "Nôp đơn mới khác",
  "nop-don-bo-sung-khac": "Nộp đơn bổ sung khác",
  "nop-don-tien-do-khac": "Nộp đơn tiến độ khác",
  "nop-don-tach": "Nộp đơn tách",
  "nop-don-dkm": "Nộp đơn đăng ký mới",
  "nop-don-phi-cap-bang": "Nộp đơn phí cấp bằng",
  "tra-loi-kqtdnd-don": "Trả lời KQTĐND đơn",
  "tra-loi-kqtdnd-tc-toan-bo-ra-tbcb": "Trả lời KQTĐND TC toàn bộ ra TBCB",
  "tra-loi-kqtdht": "Trả lời KQTĐHT (theo YC của Cơ quan nhà nước)",
  "tra-loi-kqtdht-loi-nv": "Trả lời KQTĐHT (do lỗi của NV)",
  "tien-do-nhap-nhieu": "Tiến độ: Nhập liệu",
  "soan-ho-so-gui-kh": "Soạn hồ sơ gửi KH",
  "hop-le-don-kdcn": "Hợp lệ đơn KDCN",
  "hop-le-don-sc-gphi": "Hợp lệ đơn SC/ GPHI",
  "ho-tro-don": "Hỗ trợ đơn",
  ...urgentTaskTypeNames,
};
export const taskTypes = {
  "ky-hd": "Ký HD",
  "tao-bl": "Tạo BL",
  "ghi-nhan-ds": "Ghi nhận DS",
  "xuat-hoa-don": "Xuất hóa đơn",
  "nop-don": "Nôp đơn mới khác",
  "nop-don-bo-sung-khac": "Nộp đơn bổ sung khác",
  "nop-don-tien-do-khac": "Nộp đơn tiến độ khác",
  "nop-don-tach": "Nộp đơn tách",
  "nop-don-dkm": "Nộp đơn đăng ký mới",
  "nop-don-phi-cap-bang": "Nộp đơn phí cấp bằng",
  "rut-don": "Rút đơn",
  "tien-do-nhap-nhieu": "Tiến độ: Nhập liệu",
  "giao-nhan-ho-so": "Giao/Nhận hồ sơ",
  "kd-gap": "Gấp",
  "cong-viec-khac": "Công việc khác",
  "soan-ho-so-gui-kh": "Soạn hồ sơ gửi KH",
  "tra-loi-kqtdnd-don": "Trả lời KQTĐND đơn",
  "tra-loi-kqtdnd-tc-toan-bo-ra-tbcb": "Trả lời KQTĐND TC toàn bộ ra TBCB",
  "hop-le-don-kdcn": "Hợp lệ đơn KDCN",
  "hop-le-don-sc-gphi": "Hợp lệ đơn SC/ GPHI",
  "tra-loi-kqtdht": "Trả lời KQTĐHT (theo YC của Cơ quan nhà nước)",
  "tra-loi-kqtdht-loi-nv": "Trả lời KQTĐHT (do lỗi của NV)",
  "ho-tro-don": "Hỗ trợ đơn",
  ...urgentTaskTypeNames,
};

export const taskTypesForReport = {
  "nop-don": "Nôp đơn mới khác",
  "nop-don-bo-sung-khac": "Nộp đơn bổ sung khác",
  "nop-don-tien-do-khac": "Nộp đơn tiến độ khác",
  "nop-don-tach": "Nộp đơn tách",
  "nop-don-dkm": "Nộp đơn đăng ký mới",
  "nop-don-phi-cap-bang": "Nộp đơn phí cấp bằng",
  "tra-loi-kqtdnd-don": "Trả lời KQTĐND đơn",
  "tra-loi-kqtdnd-tc-toan-bo-ra-tbcb": "Trả lời KQTĐND TC toàn bộ ra TBCB",
  "tra-loi-kqtdht": "Trả lời KQTĐHT (theo YC của Cơ quan nhà nước)",
  "tra-loi-kqtdht-loi-nv": "Trả lời KQTĐHT (do lỗi của NV)",
  "soan-ho-so-gui-kh": "Soạn hồ sơ gửi KH",
  "hop-le-don-kdcn": "Hợp lệ đơn KDCN",
  "hop-le-don-sc-gphi": "Hợp lệ đơn SC/ GPHI",
  "ky-hd": "Ký HD",
  "tao-bl": "Tạo BL",
  "ghi-nhan-ds": "Ghi nhận DS",
  "xuat-hoa-don": "Xuất hóa đơn",
  "tien-do-nhap-nhieu": "Tiến độ: Nhập liệu",
  "giao-nhan-ho-so": "Giao/Nhận hồ sơ",
  "kd-gap": "Gấp",
  "rut-don": "Rút đơn",
  "cong-viec-khac": "Công việc khác",
  "ho-tro-don": "Hỗ trợ đơn",
  ...urgentTaskTypeNames,
};

class EditableCell extends React.Component {
  _renderTypeOptions = (selectOptions) => {
    const keys = Object.keys(selectOptions);
    const urgentKeys = keys.filter(isUrgentTaskType);
    const normalOptions = keys
      .filter((key) => !isUrgentTaskType(key))
      .map((key) => (
        <Option key={key} value={key}>
          {selectOptions[key]}
        </Option>
      ));
    if (!urgentKeys.length) {
      return normalOptions;
    }
    return [
      <OptGroup key="urgent" label="⚡ Hồ sơ gấp (tính điểm)">
        {urgentKeys.map((key) => (
          <Option key={key} value={key}>
            <span className="request-task-input__urgent-option">
              {selectOptions[key]}
              <b>×{urgentTaskTypes[key].weight}</b>
            </span>
          </Option>
        ))}
      </OptGroup>,
      <OptGroup key="normal" label="Xử lý">
        {normalOptions}
      </OptGroup>,
    ];
  };

  _getInput = (props) => {
    if (this.props.inputType === "EmployeeSelect") {
      return <EmployeeSelect {...props} size="small" />;
    }
    if (this.props.inputType === "number") {
      return <InputNumber {...props} size="small" />;
    }
    if (this.props.inputType === "DatePicker") {
      return (
        <DateInput
          {...props}
          style={{ width: "100%" }}
          placeholder="Chọn ngày"
          format="DD/MM/YYYY HH:mm"
          allowClear={false}
          size="small"
        />
      );
    }
    if (this.props.inputType === "TypeSelect") {
      console.log(this.props, "this.propsselectOptions");
      return (
        <Select {...props} size="small" dropdownMatchSelectWidth={false}>
          {this._renderTypeOptions(this.props.selectOptions)}
        </Select>
      );
    }

    return <InputInTable {...props} />;
  };

  renderCell = ({ form: { getFieldDecorator, setFieldsValue } }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      onClick,
      editable,
      inputOption,
      addRow,
      inputProps,
      selectOptions,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              ...inputOption,
              initialValue: record[dataIndex],
            })(
              this._getInput({
                onPressEnter: addRow,
                ...(inputProps || {}),
              }),
            )}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  render() {
    return (
      <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
    );
  }
}

type PriceQuotationItemInfo = {
  index: Number,
  name: string,
  price: Number,
  quantity: Number,
  total_money: Number,
  currency: string,
  mode: string,
};

type RequestTaskInputProps = {
  value: PriceQuotationItemInfo[],
  onChange: (changedValue: PriceQuotationItemInfo[]) => void,
};

class EditableTable extends React.PureComponent<RequestTaskInputProps> {
  constructor(props) {
    super(props);
    this.state = { data: [], editingKey: "" };
  }

  static getDerivedStateFromProps(props) {
    console.log("itemInfoitemInfoitemInfo input: ", props.value);
    return {
      data: props.value || [],
    };
  }

  _addRow = () => {
    const { onChange, form } = this.props;
    const { data } = this.state;
    form.validateFields((error, values) => {
      if (error) {
        return;
      }
      console.log("values", values);
      const newIndex = data.length > 0 ? data[data.length - 1].index + 1 : 0;
      const newData = [...data, { index: newIndex, ...values }];
      this.setState(
        {
          data: newData,
        },
        () => {
          onChange && onChange(newData, { index: newIndex, ...values });
        },
      );
      form.resetFields();
    });
  };

  _onCheckDone = (item) => () => {
    const { onCheckDone, disabledDoneCheckbox, userState } = this.props;
    const identification = userState ? String(userState.identification) : "";    
    const isAssignedToMe = userState
      ? String(item.user_id_b) === String(userState.id)
      : false;    
    if (
      disabledDoneCheckbox ||
      !userState ||
      (!isAssignedToMe)
    ) {
      return;
    }
    const { data } = this.state;
    item.is_done = 1;
    const itemIndex = data.indexOf(item);
    const newTasks = [...data];
    if (itemIndex >= 0) {
      newTasks[itemIndex] = {
        ...item,
        is_check_done: 1,
      };
    }

    onCheckDone && onCheckDone(newTasks, { ...item, is_check_done: 1 });
  };

  _deleteRow = (key) => () => {
    const { onChange } = this.props;
    const { data } = this.state;
    const newData = data.filter((item) => key !== item.index);
    this.setState(
      {
        data: newData,
      },
      () => {
        onChange && onChange(newData);
      },
    );
  };

  _getColumns = () => {
    const {
      disabled,
      form,
      disabledDoneCheckbox,
      userState,
      mode,
    } = this.props;
    const identification = userState ? String(userState.identification) : "";    
    const startDate =
      form.getFieldValue("start") || moment().format("DD/MM/YYYY HH:mm");
    return [
      {
        title: "Ngày bắt đầu",
        dataIndex: "start",
        inputType: "DatePicker",
        width: "14%",
        render: (text) => moment(text).format("DD/MM/YYYY HH:mm"),
        editable: false,
        inputProps: {
          onChange: (startDate) => {
            const deadline = form.getFieldValue("deadline");
            if (deadline && moment(deadline).isBefore(startDate)) {
              form.setFieldsValue({
                deadline: null,
              });
            }
          },
        },
        inputOption: {
          rules: [
            {
              required: true,
              message: " ",
            },
          ],
        },
      },
      {
        title: "Ngày kết thúc",
        dataIndex: "deadline",
        inputType: "DatePicker",
        width: "14%",
        editable: true,
        render: (text) => moment(text).format("DD/MM/YYYY HH:mm"),
        inputProps: {
          // disabled: !startDate,
          disabledDate: (currDate) => {
            if (!startDate) {
              return true;
            }
            return moment(startDate, "DD/MM/YYYY HH:mm").isAfter(currDate);
          },
        },
        inputOption: {
          rules: [
            {
              required: true,
              message: " ",
            },
          ],
        },
      },
      {
        title: "Loại (Kinh doanh)",
        dataIndex: "task_type",
        inputType: "TypeSelect",
        selectOptions: taskTypesKinhDoanhForSelectOnly,
        width: "14%",
        render: (text) => taskTypesKinhDoanhForSelectOnly[text],
        editable: true,
        inputOption: {
          rules: [
            {
              required: true,
              message: " ",
            },
          ],
        },
      },
      {
        title: "Loại (Xử lý)",
        dataIndex: "task_type",
        inputType: "TypeSelect",
        selectOptions: taskTypesXuLyForSelectOnly,
        width: "14%",
        render: (text) => taskTypesXuLyForSelectOnly[text],
        editable: true,
        inputOption: {
          rules: [
            {
              required: true,
              message: " ",
            },
          ],
        },
      },
      {
        title: "Nội dung",
        dataIndex: "content",
        editable: true,
        width: "14%",
        inputOption: {
          rules: [
            {
              required: true,
              message: " ",
            },
          ],
        },
      },
      {
        title: "NVa",
        dataIndex: "user_id_a",
        inputType: "EmployeeSelect",
        width: "14%",
        render: (text) => <EmployeeInfoView id={text} />,
        inputProps: {
          disabled: true,
        },
        editable: true,
        inputOption: {
          rules: [
            {
              required: true,
              message: " ",
            },
          ],
        },
      },
      {
        title: "NVb",
        dataIndex: "user_id_b",
        inputType: "EmployeeSelect",
        width: "14%",
        render: (text) => <EmployeeInfoView id={text} />,
        editable: true,
        inputOption: {
          rules: [
            {
              required: true,
              message: " ",
            },
          ],
        },
      },
      {
        title: "Số lượng",
        dataIndex: "amount",
        editable: true,
        width: "14%",
        inputType: "number",
        inputOption: {
          rules: [
            {
              type: "number",
              message: "Vui lòng nhập số",
            },
          ],
        },
      },
      {
        title: "Xong",
        dataIndex: "is_done",
        render: (isDone, record) =>
          !isDone &&
          (mode === "create" ||
            !userState ||
            record.index === "__add_new__" ||
            (
              String(record.user_id_b) !== String(userState.id) &&
              String(record.user_id_a) !== String(userState.id))) ? null : (
            <Checkbox
              checked={!!isDone}
              disabled={!!isDone || !!disabledDoneCheckbox}
              onChange={this._onCheckDone(record)}
            />
          ),
      },
      {
        title: "Không ghi nhận",
        dataIndex: "not_recorded",
        render: (notRecorded, record) =>
          mode === "create" || record.index === "__add_new__" ? null : (
            <Checkbox
              checked={!!notRecorded}
              disabled={!canSetTaskNotRecorded(userState)}
              onChange={(e) =>
                this.props.onToggleNotRecorded &&
                this.props.onToggleNotRecorded(record, e.target.checked)
              }
            />
          ),
      },
      {
        title: "",
        dataIndex: "operation",
        render: (text, record) =>
          !disabled &&
          (record.index === "__add_new__" ? (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={this._addRow}
              size="small"
            />
          ) : null),
      },
    ];
  };

  _getRowClassName = (record) => {
    let className = "editable-row";
    if (record.is_done) {
      className += " request-task-input__done-task";
    }
    if (record.task_type === "ghi-nhan-ds") {
      className += " request-task-input__ghi-nhan-ds-task";
    }
    if (isUrgentTaskType(record.task_type) && !record.is_done) {
      className += " request-task-input__urgent-task";
    }
    if (record.not_recorded) {
      className += " request-task-input__not-recorded-task";
    }
    return className;
  };

  render() {
    const { form, disabled, userState } = this.props;

    const components = {
      body: {
        cell: EditableCell,
      },
    };

    const columns = this._getColumns().map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: col.inputType,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: record.index === "__add_new__",
          inputOption: col.inputOption,
          inputProps: col.inputProps,
          selectOptions: col.selectOptions,
          addRow: this._addRow,
        }),
      };
    });

    const dataSource = [...this.state.data];
    if (!disabled) {
      dataSource.push({
        index: "__add_new__",
        user_id_a: userState ? userState.id : null,
        start: moment().format("YYYY-MM-DD HH:mm"),
      });
    }

    console.log("dataSource", dataSource);
    return (
      <EditableContext.Provider value={{ form, disabled }}>
        <Table
          rowClassName={this._getRowClassName}
          rowKey="index"
          components={components}
          bordered
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          size="small"
        />
      </EditableContext.Provider>
    );
  }
}

let RequestTaskInput = Form.create({})(EditableTable);
RequestTaskInput = connect((state) => ({
  userState: state.app.userState,
}))(RequestTaskInput);

export default RequestTaskInput;
